import { render, staticRenderFns } from "./EditSocmed.vue?vue&type=template&id=6eea62d9&scoped=true&"
import script from "./EditSocmed.vue?vue&type=script&lang=js&"
export * from "./EditSocmed.vue?vue&type=script&lang=js&"
import style0 from "./EditSocmed.vue?vue&type=style&index=0&id=6eea62d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eea62d9",
  null
  
)

export default component.exports